import React, { Fragment } from 'react'
import { Button, FormGroup, Input, Label } from './theme'

const NewProjectForm = ({ currentValue, onChange, onSubmit }) => (
  <Fragment>
    <FormGroup>
      <Label htmlFor={'project_name'}>Nadaj nazwę dla projektu</Label>
      <Input name={'project_name'} value={currentValue} onChange={onChange} />
    </FormGroup>
    <Button onClick={onSubmit}>Dodaj</Button>
  </Fragment>
)

export default NewProjectForm



// WEBPACK FOOTER //
// ./src/containers/NewProjectForm/struct.js